import {ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {CustomStickerPageLayoutComponent} from "../../components/custom-sticker-page-layout/custom-sticker-page-layout.component";

@Component({
  selector: 'vb-create-sticker-sheet-view',
  templateUrl: './create-sticker-sheet-view.component.html',
  styleUrls: ['./create-sticker-sheet-view.component.css']
})
export class CreateStickerSheetViewComponent extends AbstractVisbosComponent implements OnInit {

  @ViewChild('customPageLayout')
  customPageLayout: CustomStickerPageLayoutComponent;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef) {
    super(sessionActions, cd);

    this.actions = [
      {
        label: 'Druckbogen speichern',
        icon: 'fa-save',
        helpText: 'Speichert den Druckbogen ab',
        action: () => this.onSaveClicked.apply(this),
        disabled: () => this.customPageLayout.control.invalid
      },
      {
        label: 'Druckbogen zurücksetzen',
        icon: 'fa-undo',
        helpText: 'Entfernt alle Spritzenetiketten vom aktuellen Druckbogen',
        action: () => this.onResetContentClicked.apply(this)
      }
    ]

  }

  ngOnInit() {
    super.ngOnInit();
  }

  onSaveClicked() {
    this.customPageLayout.createStickerSheet();
  }

  onResetContentClicked() {
    this.customPageLayout.resetContent();
  }

}



// WEBPACK FOOTER //
// ./src/app/medicine-stickers/view-components/create-sticker-sheet-view/create-sticker-sheet-view.component.ts